import { useState } from 'react';
import { activateAccount as activateAccountService } from '../../../services/user/UserService';

interface Values {
  isLoading: boolean;
  activateAccount: (token: string) => Promise<boolean>;
}

const useActivateAccount = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const activateAccount = async (token: string): Promise<boolean> => {
    try {
      setIsLoading(true);
      const result = await activateAccountService(token);
      if (result.data === true) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        return false;
      }
    } catch (error) {
      setIsLoading(false);
      return false;
    }
  };

  return { activateAccount, isLoading };
};

export default useActivateAccount;
